import WVFormatter from '../../../../../../shared/helpers/WVFormatter';

export default (props) => {
  const { record } = props;
  return typeof record.params.payout !== 'undefined' && record.params.payout !== null ? WVFormatter.formatCurrency(record.params.payout) : '';
};
